export class NetworkError extends Error
{
    public readonly httpStatusCode: number;

    constructor(message: string = "Network error.", httpStatusCode: number = 400)
    {
        super(message);
        Object.setPrototypeOf(this, NetworkError.prototype); // Extending native object.
        this.message = message;
        this.name = "NetworkError";
        this.stack = (new Error()).stack;
        this.httpStatusCode = httpStatusCode;
    }
}
